export default "__VITE_ASSET__D8Eft0vg__"